import * as WEBIFC from "web-ifc";
import * as OBC from "@thatopen/components";
import Experience from '../Experience.js';


/**
 * Loads IFC files
 */
export default class IFCFileLoader 
{
    constructor() {

        this.experience = new Experience();
        this.components = this.experience.components;
        this.world = this.experience.world;
        this.fragmentIfcLoader = this.components.get(OBC.IfcLoader);
        this.ifcManager = this.fragmentIfcLoader.ifcManager;
        this.indexer = this.components.get(OBC.IfcRelationsIndexer);
        this.elementModelManager = this.experience.elementmodelmanager;
        this.setupIFCLoader();
    }

    /**
     * Setup for IFCLoader
     */
    async setupIFCLoader() 
    {
        await this.fragmentIfcLoader.setup();
        const excludedCats = [
            WEBIFC.IFCTENDONANCHOR,
            WEBIFC.IFCREINFORCINGBAR,
            WEBIFC.IFCREINFORCINGELEMENT,
        ];

        for (const cat of excludedCats) {
            this.fragmentIfcLoader.settings.excludedCategories.add(cat);
        }

        this.fragmentIfcLoader.settings.webIfc.COORDINATE_TO_ORIGIN = false;


    }
}





